export default {
    mutations: {
        SET_AUTHENTICATED_USER: 'muven-admin.mutations:set-user-authenticated',
        SET_AUTHENTICATED_USER_ROLES: 'muven-admin.mutations:set-user-authenticated-roles',
        SET_SUBSCRIBER_LIST: 'muven-admin.mutations:set-subscriber-list',
        SET_STORE_LIST: 'muven-admin.mutations:set-store-list',
        SET_SUBSCRIBER: 'muven-admin.mutations:set-subscriber',
    },
    actions: {
        GET_AUTHENTICATED_USER: 'muven-admin.actions:get-user-authenticated',
        GET_AUTHENTICATED_USER_ROLES: 'muven-admin.actions:get-user-authenticated-roles',
        SET_AUTHENTICATED_USER_ROLES: 'muven-admin.actions:set-user-authenticated-roles',
        GET_SUBSCRIBER_LIST: 'muven-admin.actions:get-subscriber-list',
        GET_STORE_LIST: 'muven-admin.actions:get-store-list',
        SET_SUBSCRIBER: 'muven-admin.actions:set-subscriber',       
    },
}
